"use client";

import { useSearchParams } from "next/navigation";
import { X } from "lucide-react";
import { useURLDeleteKeys } from "@/hooks/useURLState";

const filterLabels: Record<string, string> = {
    q: "Search", make: "Make", model: "Model", bodystyle: "Body type",
    price: "Price", mileage: "Mileage", year: "Year", collection: "Collection",
    transmission: "Transmission", fuel: "Fuel", train: "Drivetrain", cylinder: "Cylinders",
    engine: "Engine", doors: "Doors", excolor: "Exterior", incolor: "Interior"
};

function AppliedFilter({ filterKey, label }: { filterKey: string; label: string }) {
    const [remove, pending] = useURLDeleteKeys(filterKey === "make" ? ["make", "model", "page"] : [filterKey, "page"]);
    return (
        <button type="button" onClick={remove} disabled={pending} aria-label={`Remove ${label} filter`}
            className="t-inline-flex t-min-h-11 t-max-w-full t-items-center t-gap-2 t-rounded-none t-border t-border-brand-violet/20 t-bg-brand-lavender/20 t-px-3 t-py-2 t-text-xs t-font-medium t-text-brand-violet disabled:t-opacity-50">
            <span>{label}</span><X className="t-h-3 t-w-3 t-flex-shrink-0" aria-hidden="true" />
        </button>
    );
}

export default function MobileAppliedFilters() {
    const params = useSearchParams();
    const activeKeys = Object.keys(filterLabels).filter(key => params.get(key));
    const [clear, pending] = useURLDeleteKeys([...Object.keys(filterLabels), "page"]);
    if (!activeKeys.length) return null;

    return (
        <div className="t-mt-3 t-flex t-flex-wrap t-gap-2 lg:t-hidden" aria-label="Applied filters">
            {activeKeys.map(key => {
                const values = params.getAll(key);
                let value = values.join(", ");
                if (["price", "mileage", "year"].includes(key) && values.length === 2) {
                    const format = (raw: string) => key === "year" ? raw : `${key === "price" ? "$" : ""}${Number(raw).toLocaleString("en-US")}`;
                    value = `${format(values[0]!)}–${format(values[1]!)}${key === "mileage" ? " mi" : ""}`;
                }
                if (key === "collection" && value === "smartbuys") value = "SMARTBUYS";
                return <AppliedFilter key={key} filterKey={key} label={`${filterLabels[key]}: ${value}`} />;
            })}
            <button type="button" onClick={clear} disabled={pending} className="t-min-h-11 t-px-2 t-text-xs t-font-semibold t-text-brand-violet t-underline">Clear all</button>
        </div>
    );
}
